import { render } from "./viewReportShort.vue?vue&type=template&id=284667e6&scoped=true"
import script from "./viewReportShort.vue?vue&type=script&lang=js"
export * from "./viewReportShort.vue?vue&type=script&lang=js"

import "./viewReportShort.vue?vue&type=style&index=0&id=284667e6&lang=less&scoped=scoped"

import exportComponent from "E:\\claude_code\\healthmall\\tongue_desktop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-284667e6"]])

export default __exports__